<button
  *ngIf="menu"
  type="button"
  class="fc-button"
  [class.fc-button--primary]="primary"
  [class.fc-button--outline]="outline"
  [class.fc-button--large]="large"
  [disabled]="disabled"
  [matMenuTriggerFor]="menu"
  (click)="click.emit($event)"
>
  <span>{{ label }}</span>
  <div class="arrow"></div>
  <div class="line"></div>
</button>
<button
  *ngIf="!menu"
  type="button"
  class="fc-button"
  [class.fc-button--primary]="primary"
  [class.fc-button--outline]="outline"
  [class.fc-button--large]="large"
  [disabled]="disabled"
  (click)="click.emit($event)"
>
  <span>{{ label }}</span>
</button>
